// extracted by mini-css-extract-plugin
module.exports = {"link":"_1rPxv","linkLight":"_343_2","wrapperVertical":"JLlJm"};